import { ThemeOptions } from '@mui/material';
import { kiwiGreen } from '@cogneed/design-system';

// Re-applies the handful of settings live's previous hand-rolled theme
// (src/theme.tsx, now removed) set differently from design-system's
// MainThemeProvider base, so switching to OverrideThemeProvider is a
// visual no-op.
const liveThemeOverride: ThemeOptions = {
  palette: {
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    // live never customized h1/h2 (unlike design-system's own base theme),
    // so any `variant="h1"`/`"h2"` usage across live's ~488 MUI call sites
    // rendered with MUI's plain stock styles -- restore exactly that,
    // cancelling design-system's color/margin/textTransform/weight overrides.
    h1: {
      color: 'inherit',
      fontWeight: 300,
      fontSize: '6rem',
      lineHeight: 1.167,
    },
    h2: {
      color: 'inherit',
      fontWeight: 300,
      fontSize: '3.75rem',
      lineHeight: 1.2,
      textTransform: 'none',
      marginTop: 0,
      marginBottom: 0,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          backgroundColor: kiwiGreen[100],
          color: kiwiGreen[600],
          '& .MuiSvgIcon-root': {
            color: kiwiGreen[600],
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
};

export default liveThemeOverride;
